export const BUSINESS_MANAGER = 'BUSINESS_MANAGER';
export const GROUP_MANAGER = 'GROUP_MANAGER';
export const ORG_ADMIN = 'ORG_ADMIN';
export const ADMIN = 'ADMIN';
export const PROVIDER = 'PROVIDER';
